/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    AboutMenu,
    Category,
    MenuAboutType,
    MenuType,
} from "@hermes/api-model-menu";

/**
 * Safe access to editorial data in menu entry
 */
export const getDiscoveryEdito = (entry: Category): any | undefined => {
    if (entry.type === MenuType.TYPE_PUSH) {
        const pushItem: any = {
            path: entry.path ?? "",
            title: entry.title ?? "",
            image: entry.image ?? "",
        };

        return pushItem;
    }
    return undefined;
};

export const getDiscoveryEntryPimCode = (
    item: Category | AboutMenu,
): string | undefined => {
    if ("label" in item) {
        if (item.type === MenuAboutType.TYPE_INTERNAL_LINK) {
            return "MISSING_PIM_CODE";
        }
    } else if ("name" in item) {
        if (item.type === MenuType.TYPE_STORY) {
            return "MISSING_PIM_CODE";
        }

        return item.pimCode;
    }

    return undefined;
};

/**
 * Utility function to clean the name of a MenuEntryItem from special characters.
 * It keeps only uppercase letters, numbers, and the "&" symbol.
 * This is specifically used for entries of type "story", which don't have a pimCode,
 * so we rely on the cleaned name to send consistent analytics data from the menu.
 */

export const getFormattedDiscoveryEntryName = (
    item: Category | AboutMenu,
): string | undefined => {
    let text: string | undefined;

    if ("label" in item) {
        text = item.label;
    } else if ("name" in item) {
        text = item.name;
    }

    if (text) {
        return text
            .toUpperCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036F]/g, "")
            .replace(/[^\d&A-Z]/g, "");
    }

    return undefined;
};

export const isGridDiscoveryMenuEntry = (menuEntry: Category): boolean =>
    menuEntry.type === MenuType.TYPE_GRID;

export const isStoryDiscoveryMenuEntry = (menuEntry: Category): boolean =>
    menuEntry.type === MenuType.TYPE_STORY;

export const isOtherDiscoveryMenuEntry = (menuEntry: Category): boolean =>
    menuEntry.type === MenuType.TYPE_OTHER;
